import React from "react";

export default () =>
    <div className="head__cell cell--actions">
        Actions
    </div>;
